import cn from "classnames";
import { formatAmountValue } from "../utils";
import { LimitsHintProps } from "./types";
import styles from "./styles.module.scss";

export const LimitsHint = ({
  minValue,
  maxValue,
  className,
  dataTestId,
  currencySymbol,
}: LimitsHintProps) => {
  if (minValue === null || maxValue === null) {
    return null;
  }

  return (
    <span className={cn(styles["limits-hint-wrapper"], className)}>
      <span data-test-id={`${dataTestId}-min-value-hint`}>
        {formatAmountValue(minValue)} {currencySymbol}
      </span>
      <span data-test-id={`${dataTestId}-max-value-hint`}>
        {formatAmountValue(maxValue)} {currencySymbol}
      </span>
    </span>
  );
};
